<button
  type="button"
  class="hd-cycle-gate-keynote-line__gate"
  [class.hd-cycle-gate-keynote-line__gate--natal]="source() === 'natal'"
  [class.hd-cycle-gate-keynote-line__gate--both]="source() === 'both'"
  [attr.title]="gateTooltip()"
  (click)="onGateClick($event)"
  (mouseenter)="onGateEnter()"
  (mouseleave)="onGateLeave()"
>{{ gate() }}</button>

@if (secondaryGlyphs().length > 0) {
  <!-- Beide bronnen activeren de poort: de natal-kant (chart 1, blauw) vóór de gewone glyphs. -->
  <span class="hd-cycle-gate-keynote-line__glyphs" aria-hidden="true">
    @for (glyph of secondaryGlyphs(); track $index) {
      <span class="hd-cycle-gate-keynote-line__glyph hd-cycle-gate-keynote-line__glyph--secondary">{{ glyph }}</span>
    }
  </span>
}

@for (group of groups(); track $index) {
  <span class="hd-cycle-gate-keynote-line__planet-group">
    <span class="hd-cycle-gate-keynote-line__glyphs" aria-hidden="true">
      @for (glyph of group.glyphs; track $index) {
        <span class="hd-cycle-gate-keynote-line__glyph">{{ glyph }}</span>
      }
    </span>
    @if (group.label) {
      <span class="hd-cycle-gate-keynote-line__keynote">
        @if (group.icon) {
          <i class="fas fa-{{ group.icon }} hd-cycle-gate-keynote-line__keynote-icon" aria-hidden="true"></i>
        }
        <span class="hd-cycle-gate-keynote-line__keynote-label">{{ group.label }}</span>
      </span>
    }
  </span>
}

@if (encounterTerm()) {
  <span class="hd-cycle-gate-keynote-line__keynote hd-cycle-gate-keynote-line__encounter" [attr.title]="encounterTooltip()">
    @if (encounterIcon()) {
      <i class="fas fa-{{ encounterIcon() }} hd-cycle-gate-keynote-line__keynote-icon" aria-hidden="true"></i>
    }
    <span class="hd-cycle-gate-keynote-line__keynote-label">{{ encounterTerm() }}</span>
  </span>
}
